import { configureStore } from '@reduxjs/toolkit'
import { a11yReducer } from './slices/a11y'
import { inputReducer } from './slices/input'
import { mainReducer } from './slices/main'
import { modalReducer } from './slices/modal'
import { qrReducer } from './slices/qr'
import { selectReducer } from './slices/select'
import { supportReducer } from './slices/support'
import { tranRoutesReducer } from './slices/tranRoutes'

export const store = configureStore({
  reducer: {
    main: mainReducer,
    input: inputReducer,
    tranRoutes: tranRoutesReducer,
    support: supportReducer,
    qr: qrReducer,
    select: selectReducer,
    a11y: a11yReducer,
    modal: modalReducer,
  },
})
